import React from "react";

/**
 * El isotipo de Excelia --la «e»-- como vector.
 *
 * Va en vector y no como imagen a propósito. El archivo que publica
 * excelia.com es un JPG negro **sobre fondo blanco**, sin transparencia: en la
 * barra lateral, que es oscura, se vería como un recuadro blanco con una letra
 * dentro. Aquí el trazo toma `currentColor`, así que sale blanco donde el texto
 * es blanco y oscuro donde el fondo es claro, sin dos versiones del archivo.
 *
 * La geometría está medida sobre el original de 512 px, no estimada a ojo:
 *
 * - Caja del glifo 269 × 186 --de ahí el `viewBox`--, proporción 1,446.
 * - Trazo horizontal 29, vertical 35. La diferencia es la corrección óptica de
 *   siempre: un trazo vertical del mismo grosor que el horizontal se ve más
 *   delgado, así que se dibuja un 20 % más ancho.
 * - Esquinas exteriores: 60 arriba y abajo a la izquierda, 55 arriba a la
 *   derecha. No es una cápsula: el lado izquierdo tiene un tramo recto.
 * - La barra central va exactamente a media altura y llega hasta el borde
 *   derecho (x = 268). El trazo de abajo se corta 12 antes (x = 256), y ese
 *   escalón es lo que abre la «e».
 *
 * `fill-rule="evenodd"`: el segundo subtrazo es el hueco de arriba. El de abajo
 * no se dibuja porque no es un hueco --queda abierto hacia la derecha, y el
 * contorno exterior ya lo rodea--.
 */
const LogoExcelia = ({ size = 20, ...props }) => (
  <svg
    viewBox="0 0 269 186"
    height={size}
    width={(size * 269) / 186}
    fill="currentColor"
    fillRule="evenodd"
    focusable="false"
    aria-hidden="true"
    {...props}
    style={{ flexShrink: 0, display: "block", ...props.style }}
  >
    <path
      d="M60 0 H213 C243.4 0 268 24.6 268 55 V107 H60
         C46.2 107 35 118.2 35 132 C35 145.8 46.2 157 60 157
         H256 V185 H60 C26.9 185 0 158.1 0 125 V60 C0 26.9 26.9 0 60 0 Z
         M60 29 H208 C221.8 29 233 40.2 233 54 V72
         C233 75.3 230.3 78 227 78 H41 C37.7 78 35 75.3 35 72 V54
         C35 40.2 46.2 29 60 29 Z"
    />
  </svg>
);

export default LogoExcelia;
